export default function BtnDelSvg ({customFill}) {
    var newFill = "#9DB4FF";
    if (customFill) {
        newFill = customFill;
    }
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="https://www.w3.org/2000/svg">
            <path d="M24 2.42571L21.5743 0L12 9.57429L2.42571 0L0 2.42571L9.57429 12L0 21.5743L2.42571 24L12 14.4257L21.5743 24L24 21.5743L14.4257 12L24 2.42571Z" fill={newFill} />
        </svg>
    )
}